import React from "react";
import "../css/App.css";

const Footer = () => {
  return (
    <div class="footer-container">
      <div class="footer-left">
        <ul>
          <li>
            <i className="icon"></i>알리는 말씀
          </li>
          <li>
            <i className="icon"></i>이벤트
          </li>
          <li>
            <i className="icon"></i>사이트소개 및 안내
          </li>
          <li>
            <i className="icon"></i>자주 묻는 질문들
          </li>
          <li>
            <i className="icon"></i>개인 정보 취급 방침
          </li>
          <li>
            <i className="icon"></i>이용약관
          </li>
        </ul>
      </div>
      <div className="footer-middle">
        <p>
          관리자에게 건의, 요청, 제안 등이 있으시면 민원청구 게시판에
          올려주세요. 이메일이나 전화번호로 요청하시는 답변은 드리지 못합니다.
        </p>
        <button className="complaint-btn">민원청구</button>
      </div>
      <div className="footer-right">
        <p>© 1999 - 2024 SungHwa Community.</p>
      </div>
    </div>
  );
};

export default Footer;
